// @flow

import unifizeUser from "../index";
import ImageLabel from "src/components/user/ImageLabel/Small";

export default unifizeUser(ImageLabel);
